import { createI18n } from 'vue-i18n'
export type LocaleType = 'zh-cn' | 'en-us' | 'ru' | 'ja' | 'ko'

const i18n = createI18n({
  messages: {
    // 'zh-cn': require('./languages/zh.json'),
    // 'en-us': require('./languages/en.json')
  },
  legacy: false
})

export default i18n
